export const LOG_IN = "login.logar";
export const LOG_OUT = "login.deslogar";
export const LOG_IN_INIT = "login.iniciar_login";
export const FAIL_LOGIN = "login.falha_ao_logar";
export const LOG_IN_END = "login.terminar_login";
